module.exports = __webpack_public_path__ + "media/images/logo-xero-8651d4692168b544e9a45f73a238213d.png";